
export class Common {    
  isString(str: any): boolean {
    return str instanceof String || typeof str === "string" 
  }

  // isPrimitive(value:any) {
  //   return value !== Object(value);
  // }
  isNullOrUndefined(value:any) {
    return value === null || value === undefined;
  }
  
  //todo: 9時間移動は適当なのでテストすること
  // Date型をサーバーで読めるようにISOStringに変換 Date -> 1987-04-26
  dateToISOString(date: Date) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const utcDate = new Date(date.setHours(date.getHours() + 9)); //UTC+000と解釈するので９時間移動
      // 誕生日を文字列にする。
      return  utcDate.getUTCFullYear() +
        "-" +
        (utcDate.getUTCMonth() + 1) + //getMonthは0からなので
        "-" +
        utcDate.getUTCDate();
  }

    

  getCookie(key:string, cookie?: string): string{
    let start,end;
    if(!cookie)cookie=document["cookie"];
    start=cookie.indexOf(key + '=');
    
    if(start>=0){
      start+=key.length + 1;
      end=cookie.indexOf(';',start);
      if(end<0){
        end=cookie["length"];
      }
      if(start < end){
        return cookie.substring(start, end);
      }
    }
    return "";
  }


  //ブラウザで開いているwindowの幅。コンテンツの幅ではない
  getWindowWidth(){
    //なぜかmobileモードで画面開いた直後の大きさがずれるので、window.innerWidthは２番手、document.body.clientWidthは意図する大きさではないので３番手
    //また<!DOCTYPE html>の有無によっても値が変わるので、build前後で値がおかしくなったら要確認
    return document.documentElement.clientWidth || window.innerWidth || document.body.clientWidth;
  }  
  getWindowHeight(){
    //なぜかmobileモードで画面開いた直後の大きさがずれるので、window.innerWidthは２番手、document.body.clientWidthは意図する大きさではないので３番手
    //また<!DOCTYPE html>の有無によっても値が変わるので、build前後で値がおかしくなったら要確認
    return document.documentElement.clientHeight || window.innerHeight || document.body.clientHeight;
  }

  deepCopy<T>(obj:T) :T {
    //関数はコピーされないので注意
    return JSON.parse(JSON.stringify(obj))
  }

  copyProperties(obj:any, list:string[]){
    const ret = {} as any;
    list.forEach(key => {
      ret[key] = obj[key];
    })
    return ret;
  }
  
  getAllKeys(obj:any) {
    const result = [];
    for (const prop in obj) {
      result.push(prop);
    }
    return result;
  }

  //{a:1, b:2}と{b:2, a:1}の順を揃えたオブジェクトを作成
  createOrderedObject(obj:any){
    if(!obj){
      return obj
    }

    if (typeof obj === 'string' || obj instanceof String){
      return obj
    }

    const keys = Object.getOwnPropertyNames(obj);
    if(keys.length === 0){
      return obj 
    }

    const ret = {} as any
    keys.sort().forEach(key =>{
      ret[key] = this.createOrderedObject(obj[key])
    })
    return ret
  }

  customParseInt(val:string){
    if(val === "null"){
      return null;
    }else if(val === "undefined"){
        return null;
    }else{
      return parseInt(val)
    }
  }

  //処理を一旦停止する。<script>の処理を一旦とめて、次のタグを読み込むため（次のタグで画像読込の処理が来る場合がある）
  runInNextTick(func:()=>void){
    setTimeout(func, 0);
  }


  getRandomChar(){
    return String.fromCharCode(97 + Math.floor( Math.random() * 26)) 
  }
  getRandomString(len:number){
    let ret = "";
    for(let i = 0; i < len; ++i){
      ret += this.getRandomChar();
    }
    return ret;
  }



  
  getMergedTitle<T>(list: T[], propName:keyof T, noTitle:string, maxLength:number){
    if(list.length === 0){
        return noTitle;
    }
    if(list.length === 1){
        return list[0][propName] ? list[0][propName] : noTitle;
    }
    let result = "";
    list.forEach((publicPage, index) =>{
        let text = publicPage[propName] ? publicPage[propName]as string : noTitle;
        if(text.length > maxLength){
            text = text.substring(0, maxLength);
        }
        if(index > 0){
            result += ", " 
        }
        result += text 
    })
    return result
  }


  private windowScroll = -1;
  public carryOverWindowScroll(){
    this.windowScroll = window.scrollY
  }
  public setCarriedWindowScroll(){
    if(this.windowScroll >= 0 ){
      window.scrollTo(0, this.windowScroll)
      this.windowScroll = -1
    }
  }
  public removeStartDots(str: string): string {
    return str.replace(/^\.+/, '').replace(/\/\.+/, '');
  }

  public hasDifferentValue(obj1:any, obj2:any){
    for(const key in obj1){
      if(obj1[key] !== obj2[key]){
        return true
      }
    }
    return false
  }

  public isElementInViewport(el: Element, topMargin:number): boolean {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight + topMargin &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.right > 0
    );
  }

  public scrollToElement(el: HTMLElement, hashId?:string) {
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (hashId) {
      //理由はわからないけど、chromeで同一のhashを入れた状態で、さらにhashを入れないと画面遷移しなかった(2025/07/05)
      location.href = `#${hashId}`;
      setTimeout(() => {
        location.href = `#${hashId}`;
      }, 0);
    }
  }

  public flashBackground(el:HTMLElement, color = '#ffffe0', duration = 700) {
    if (!el) return
    const original = el.style.backgroundColor;
    el.style.transition = 'background-color 0.7s'
    el.style.backgroundColor = color
    setTimeout(() => {
      el.style.backgroundColor = original
    }, duration);
  }
}

export default new Common();
